import { BaseModel } from '../../../models/base-model'
import { ResourceType } from './resource-type'

export class Resource extends BaseModel {
  public name: string
  public description: string
  public resourceType: ResourceType
  public uri: string
  public thumbnailUri: string

  public getResourceTypeAsString(): string {
    return ResourceType[this.resourceType]
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/data/models/resource/resource.ts